import React, { Fragment } from 'react';
import { Layout as DefaultLayout } from '../Layout';
import Login from '../Auth/Login';
import LocationStep from '../Project/Create/Steps/Location';
import EstimateBudgetStep from '../Project/Create/Steps/EstimateBudget';
import DetailsStep from '../Project/Create/Steps/Details';
import Sprint2Step4 from "../Project/Create/Steps/Layout/Sprint2Step4";
import Sprint2Step5 from "../Project/Create/Steps/Layout/Sprint2Step5";
import Sprint2Step5Successfull from "../Project/Create/Steps/Layout/Sprint2Step5Successfull";
import ContractorChoose from '../Project/Create/Steps/EstimateBudget/Contractor/Choose';
import Success from '../Project/Create/Steps/Success';
import AboutBuilde from '../Landing/AboutBuilde';
import UploadPhotoStep from '../Project/Create/Steps/UploadPhoto';
import AddItemsStep from '../Project/Create/Steps/EstimateBudget/AddItems';
import AboutBuildeAi from '../Landing/AboutBuildeAi';

const layouts = [
  {
    target: <Login/>,
    element: Fragment
  },
  {
    target: <UploadPhotoStep/>,
    element: Fragment
  },
  {
    target: <AddItemsStep/>,
    element: Fragment
  },
  {
    target: <LocationStep/>,
    element: Fragment
  },
  {
    target: <EstimateBudgetStep/>,
    element: Fragment
  },
  {
    target: <DetailsStep/>,
    element: Fragment
  },
  {
    target: <ContractorChoose/>,
    element: Fragment
  },
  {
    target: <Sprint2Step4/>,
    element: Fragment
  },
  {
    target: <Success/>,
    element: Fragment
  },
  {
    target: <Sprint2Step5/>,
    element: Fragment
  },
  {
    target: <Sprint2Step5Successfull/>,
    element: Fragment
  },
  {
    target: <AboutBuilde/>,
    element: Fragment
  },
  {
    target: <AboutBuildeAi/>,
    element: Fragment
  }
]

function LayoutResolver({element, rest}) {
  const resolveLayout = () => {
    const resolved = layouts.find((layout) => layout.target.type === element.type);
    return resolved !== undefined ? resolved.element : DefaultLayout;
  }

  const LayoutComponent = resolveLayout();

  return (
    <LayoutComponent>
      {element}
    </LayoutComponent>
  );
}

export default LayoutResolver;
